"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../index");

var _user = require("./user.styles");

var _jsxRuntime = require("react/jsx-runtime");

const defaultProps = {
  size: 'lg',
  squared: false,
  bordered: false
};
const preClass = 'nextui-user';

const User = ({
  src,
  text,
  name,
  children,
  altText,
  color,
  squared,
  bordered,
  size,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_user.StyledUser, { ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.Avatar, {
      className: `${preClass}-avatar`,
      src: src,
      color: color,
      squared: squared,
      bordered: bordered,
      text: text,
      size: size,
      alt: altText
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_user.StyledUserInfo, {
      className: `${preClass}-info`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_user.StyledUserName, {
        className: `${preClass}-name`,
        children: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_user.StyledUserSocial, {
        className: `${preClass}-social`,
        children: children
      })]
    })]
  });
};

User.toString = () => '.nextui-user';

var _default = /*#__PURE__*/_react.default.memo(User);

exports.default = _default;
module.exports = exports.default;